const SPREADING_JOBS = () => `/jobs/spreading`
const SPREADING_JOBS_BY_ID = (id: string) => `${SPREADING_JOBS()}/${id}`
export const SPREADING_JOB_EXPORT = () => `${SPREADING_JOBS()}/export`

export default {
  SPREADING_JOBS,
  SPREADING_JOBS_BY_ID,
  SPREADING_JOB_EXPORT
}
